import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useVerifiedAddressQuery } from 'gql/__generated/vp-apollo';

type RequireVerifiedAddressProps = PropsWithChildren<{
    redirectTo: string;
}>;

export const RequireVerifiedAddress = ({ redirectTo, children }: RequireVerifiedAddressProps) => {
    const { data } = useVerifiedAddressQuery();
    return data?.verifiedAddress ? <>{children}</> : <Navigate replace to={redirectTo} />;
};
